export const LinkedInIcon = () => {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1702_87)">
        <path
          d="M0 2.59c0-.605.203-1.105.608-1.5C1.014.698 1.541.5 2.19.5c.637 0 1.153.194 1.547.582.405.4.608.92.608 1.563 0 .582-.197 1.067-.591 1.455-.405.4-.938.6-1.599.6h-.017C1.5 4.7.985 4.5.591 4.1.197 3.7 0 3.197 0 2.59zM.226 18.5V6.354h3.857V18.5H.226zm5.994 0h3.857v-6.782c0-.424.047-.752.14-.982.161-.412.407-.76.738-1.045.33-.285.744-.428 1.242-.428 1.297 0 1.946.915 1.946 2.746v6.49H18v-6.963c0-1.794-.405-3.154-1.216-4.082-.811-.927-1.882-1.39-3.214-1.39-1.495 0-2.659.672-3.493 2.018v.036h-.017l.017-.036V6.354H6.22c.023.388.035 1.594.035 3.618 0 2.025-.012 4.867-.035 8.528z"
          fill="#697484" // is changing to #fff by hover
        />
      </g>
      <defs>
        <clipPath id="clip0_1702_87">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
